<template>
  <div style="margin-top: 20px; margin-bottom: 20px;">
    <h1 class="u">Заявки <router-link class="btn btn-primary" :to="{ name: 'claim-add' }">+ Добавить заявку</router-link></h1>

    <resource-list
      url="/claims"
      current-sort="text"
      resource-name="claims"
      :action-routes="actionRoutes"
      :fields="fields"
      :filters="filters"
    />

  </div>
</template>

<script>
import resourceList from '@/components/ResourceList'

export default {
  name: 'claims',
  components: { resourceList },
  data () {
    return {
      fields: [
        { name: 'full_name', label: 'Клиент', sort: false },
        { name: 'text', label: 'Текст', sort: false },
        { name: 'datetime', label: 'Дата и время', sort: true, datetime: true }
      ],
      filters: {
        client: ''
      },
      actionRoutes: [
        { name: 'claim-details', label: 'Открыть детали' }
      ]
    }
  }
}
</script>


// WEBPACK FOOTER //
// Claims.vue?4b1342ae